export const MenuItems: { translate: string; gtm: string; link?: string; href?: string; header: boolean }[] = [
  {
    translate: 'buy',
    gtm: 'nabidka',
    link: 'list',
    header: true,
  },
  {
    translate: 'sell',
    gtm: 'sell',
    link: 'sellCar',
    header: true,
  },
  {
    translate: 'rent',
    gtm: 'rent',
    href: 'https://www.mototechnadrive.cz/',
    header: true,
  },
  {
    translate: 'aboutCompany',
    gtm: 'aboutCompany',
    link: 'aboutCompany',
    header: false,
  },
  {
    translate: 'services',
    gtm: 'services',
    link: 'services',
    header: true,
  },
  {
    translate: 'contact',
    gtm: 'contact',
    link: 'contact',
    header: true,
  },
];
